import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { AutomationLogsListStore } from './automationLogsListStore'

export class AutomationLogsStore {
  private _showAlert = false
  private readonly _listStore: AutomationLogsListStore

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
    this._listStore = new AutomationLogsListStore(this._entities)
    this._init()
  }

  get showAlert() {
    return this._showAlert
  }

  get listStore() {
    return this._listStore
  }

  get canCloseAlert() {
    return true
  }

  get userId() {
    return this._entities.usersStore.user?.id || 0
  }

  get alertShowCountFlagName() {
    return `${this.userId}_automationLogsAlert_show_count`
  }

  get alertShowCountValue() {
    const count = window.localStorage.getItem(this.alertShowCountFlagName)
    return count ? parseInt(count) : 0
  }

  closeAlert = async () => {
    window.localStorage.setItem(this.alertShowCountFlagName, String(this.alertShowCountValue + 1))
    this._showAlert = false
  }

  private _init = () => {
    this._showAlert = this.alertShowCountValue < 3
  }
}
